import { Observable, from, timer } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ISystemSettings } from '../interfaces/system-settings';
import { SettingsService } from './settings.service';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppNotificationService {
  url: string = 'api/settings';
  constructor(public http: HttpClient, private systemSettings: SettingsService) {}
  getAppMessages(): Observable<any> {
    return timer(0, 3600000).pipe(
      switchMap((num) =>
        from(
          this.systemSettings.GetSystemSettings().then((data: ISystemSettings) => {
            let systemSettings = data;
            return (data && data.appBannerNotificationMessage) || '';
          }),
        ),
      ),
    );
  }
}
